import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieSectionProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
  viewAllLink?: string;
}

export default function MovieSection({ title, subtitle, movies, viewAllLink }: MovieSectionProps) {
  return (
    <section className="w-full px-4 md:px-6 py-6 md:py-8" data-product-shop>
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-5">
          <div>
            <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
              {title}
            </h2>
            {subtitle && (
              <p className="text-xs text-foreground-500 mt-1">{subtitle}</p>
            )}
          </div>
          {viewAllLink && (
            <Link
              to={viewAllLink}
              className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-s-line"></i>
            </Link>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {movies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
                <img
                  src={movie.imageUrl}
                  alt={`${movie.title} - 悟空影视免费在线观看`}
                  title={`${movie.title} ${movie.year} - ${movie.tags.join(' ')}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500 text-white">
                    {movie.rating}
                  </span>
                </div>
                {movie.updateInfo && (
                  <div className="absolute top-2 right-2">
                    <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-black/60 text-white backdrop-blur-sm">
                      {movie.updateInfo}
                    </span>
                  </div>
                )}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/80 opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill text-lg text-primary-600"></i>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {movie.year} · {movie.region}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}